// src/language/en.js
// 定义英文语言包对象
export default {
  登录: "Log in",
  个人中心: "User Center",
  学习进度: "Learning Progress",
  邮箱: "Email",
  联系方式: "Contact Info",
  站内信: "inbox",
  官方客服: "Official support",
  调查问卷: "Survey",
  客诉通道: "Report",
  能力诊断: "Skills assessment",
  试卷题目: "Exam questions",
  多选题: "Multiple-answer question",
  单选题: "Single-answer question",
  判断题: "True or false question",
  提示: "Prompt",
  请您确认是否提交试卷: "Are you sure you want to submit this exam?",
  继续答题: "Continue exam",
  提交: "Submit",
  提交试卷: "Submit exam",
  分: "score",
  "分(秒)": "Mins",
  重新答题: "Restart quiz",
  答题记录: "Answer history",
  推荐课程: "Recommended courses",
  成绩: "Score",
  考试时长: "Exam duration",
  开始时间: "Start time",
  提交时间: "Submission time",
  操作: "Action",
  查看明细: "View details",
  查看试卷: "View exam paper",
  首页: "Home",
  人才认证: "Talent Certification",
  我的成就: "My achievements",
  更多认证: "More certifications",
  报名: "Sign up",
  证书查询: "Search certificates",
  姓名: "Learner Name",
  证书编号: "Certificate number",
  查询: "Search",
  重置: "Reset",
  学员名称: "Learner Name",
  手机号码: "Mobile number",
  身份证号码: "ID number",
  编号: "No.",
  证书名称: "Certificate name",
  有效期: "Validity period",
  下载证书: "Download certificate",
  完课考试: "Quiz",
  学习记录: "Learning records",
  学习时长: "Learning time",
  门: "courses",
  个: "certifications",
  课程名称: "Course name",
  完课率: "Completion rate",
  完课成绩: "Quiz score",
  完课时间: "Completion time",
  "抱歉，该内容已下架": "Sorry, this content is no longer available.",
  返回首页: "Back to home",
  敬请期待: "Coming soon",
  课程学习: "Study course",
  认证考试: "Certification exam",
  课程中心: "Course Center",
  全部: "All",
  请输入关键字: "Please enter a keyword",
  开始学习: "Start learning",
  课程简介: "Course overview",
  自动连播: "Auto-play",
  课程目录: "Course directory",
  本讲简介: "Lesson overview",
  小结巩固: "Summary & review",
  随堂小测: "In-class quiz",
  开始测试: "Start quiz",
  问题反馈: "Feedback",
  学员评论: "Learner comments",
  "请提出您对本章节的建议，帮助我们后续改进":
    "We welcome your suggestions for this chapter. Your feedback is valuable in helping us improve the content.",
  管理员: "Admin",
  已加载全部: "All loaded",
  没有更多了: "No more available",
  全部已读: "All read",
  删除: "Delete",
  分钟前: " min(s) ago",
  小时前: " hr(s) ago",
  天前: " day(s) ago",
  当日课程: "Courses",
  立即预约: "Enroll Now",
  立即查看: "View Now",
  您的得分为: "Your score is",
  "恭喜您通过此次考试！": "Congratulations! You have passed the exam.",
  重新考试: "Retake exam",
  继续学习: "Continue learning",
  考试次数已用尽: "Maximum attempts reached",
  考试成绩: "Exam result",
  "很遗憾,您未通过此次考试, 考试机会已用完！":
    "Unfortunately, you did not pass the exam, and you have now used all your available attempts.",
  "很遗憾,您未通过此次考试, 还剩N次考试机会！":
    "Unfortunately, you did not pass the exam, but you still have {text} more attempts left.",
  恭喜您获得了N认证证书:
    "Congratulations! You've obtained {text} certification.",
  "可前往『 我的成就-我的认证』中查看": `Go to "My achievements > My certifications" to view your certification.`,
  官方推荐: "Official Recommendations",
  官方: "Official",
  推荐: " Recommendations",
  查看更多: "View more",
  暂无数据: "No Data",
  上月: "Last",
  下月: "Next",
  今天: "Today",
  我的认证: "My Certifications",
  必看好课: "Recommended courses",
  必看: "Recommended",
  好课: " courses",
  精品课程: "Featured courses",
  "扫描群二维码,立刻加入该群": "Scan the group's QR code to join now",
  出海学堂满意度调查: "TikTok for Business Academy Satisfaction Survey",
  "从总体而言,您对该网课平台的整体满意度如何？":
    "How satisfied are you overall with your experience using our online course platform?",
  "您认为该平台所提供的课程质量如何？":
    "How are you finding the quality of courses provided by this platform?",
  "体验下来，课程视频的流畅程度是：":
    "Was the video playback smooth during the course?",
  "您认为课程内容对您的帮助程度是：":
    "How helpful was the course content for you?",
  "您是否会向其他人推荐该平台？":
    "Would you recommend this platform to others?",
  "您对该平台有任何建议或意见吗？请详细叙述您的问题便于我们改进":
    "Do you have any suggestions or feedback for this platform? Please describe your issue in detail to help us improve",
  请简述您的问题: "Please briefly describe issue(s) you encountered",
  联系我们: "Contact us",
  "关于TikTok for Business 出海学堂还有疑问？":
    "Still have questions about TikTok for Business Academy?",
  我的收藏: "My favorites",
  已学完: "Completed",
  已结束: "Ended",
  已看N: "{text} viewed",
  已看完: "Fully viewed",
  视频: "Video",
  学习资料: "Learning materials",
  N人看过: "Viewed by {text} users",
  PDF资料: "PDF materials",
  课程介绍: "Course overview",
  适用人群: "Target audience",
  讲师团队: "Instructor team",
  友情链接: "Quick link",
  商务中心: "Business Center",
  广告管理平台: "TikTok Ads Manager",
  官网: "Official website",
  条款和政策: "Terms and Policies",
  隐私条款: "Privacy policy",
  "先人一步，现在就开始了解出海学堂":
    "Stay ahead by exploring TikTok for Business Academy now",
  认证流程: "certification process",
  跨境营销认证流程: "Cross-border marketing certification process",
  报名认证: "Sign up for certification",
  模拟练习: "Practice test",
  认证考核: "Certification assessment",
  直播: "Live",
  认证: "Certifications",
  退出登录: "Log out",
  帮助: "Help",
  请输入姓名和证书编号: "Please enter your name and certificate number",
  消息: "Messages",
  我的: "Me",
  游客登录: "Log in as a visitor",
  "游 客 登 录": "Log in as a visitor",
  "TikTok for Business账号登录": "Log in with a TikTok for Business account",
  内部员工登录: "Log in using an internal account",
  "飞书群二维码，立刻加入该群": "Scan the Lark group QR code to join now",
  取消: "Cancel",
  确认: "Confirm",
  星期一: "Monday",
  星期二: "Tuesday",
  星期三: "Wednesday",
  星期四: "Thursday",
  星期五: "Friday",
  星期六: "Saturday",
  星期日: "Sunday",
  课程日历筛选: "Filter",
  课程日历: "Course calendar",
  日历: " calendar",
  "当前账号不支持此功能，请升级账号信息！":
    "The current account does not support this feature. Please upgrade your account.",
  知道了: "Got it",
  去升级: "Upgrade now",
  收藏: "Favorites",
  全部课程: "All courses",
  课程: " courses",
  课程C: " Courses",
  中心: "Center",
  请输入课程名称: "Please enter course name",
  刚刚发布: "Recently published",
  正在学习: "Now learning",
  正在: "Now",
  学习: " learning",
  总分: "Total score",
  答题时间: "Answer duration",
  "网络异常，请重试！(错误码:) ":
    "Network error. Please try again. (Error code:) ",
  "认证信息数据异常，请刷新重试":
    "Data error in displaying certification information. Please refresh and try again.",
  刷新页面: "Refresh",
  "抱歉，您还没有该课程的查看权限":
    "Sorry, you don't have permission to view this course.",
  跳转到课程中心: "Redirect to Course Center",
  代理中心: "Agency Center",
  当前主体: "Current entity",
  注册时间: "Registration date",
  已学课程数: "Completed courses",
  学习总时长: "Total learning time",
  暂无: "None",
  排行榜: "Leaderboard",
  当前排名: "Current ranking",
  排名: "Ranking",
  名称: "Name",
  "查询出错，请检查查询条件":
    "Search error. Please check your search criteria.",
  合作伙伴: "Partners",
  官方证书: "Official certificates",
  "跨境效果广告营销师（初级）":
    "Marketing Specialist - Cross-border Performance Advertising (Beginner)",
  "跨境效果广告营销师（中级）":
    "Marketing Specialist - Cross-border Performance Advertising (Intermediate)",
  认证权益: "Certification benefits",
  出海学堂学习认证流程:
    "TikTok for Business Academy learning and certification processes",
  认证体系: "Certification system",
  "跨境创意素材营销师 初级、中级":
    "Marketing Specialist - Cross-border Creative Materials (Beginner or Intermediate)",
  "专注于跨境营销中的创意素材制作与趋势分析，提升营销的创意策划能力。":
    "Focuses on the production of creative materials and trend analysis in cross-border marketing to enhance your creative planning capabilities.",
  "跨境小店投流营销师 初级、中级":
    "Marketing Specialist - Cross-border TikTok Lite Shop Advertising (Beginner or Intermediate)",
  "针对 TikTok 小店商家投流技能，培养营销人员在流量获取和转化方面的专业能力，帮助店铺实现曝光增长与业绩双增长":
    "Focuses on TikTok Lite Shop advertising skills in traffic acquisition and conversion to boost exposure and performance.",
  回复: "Reply",
  加载更多: "VIEW MORE",
  提交成功: "Submitted successfully",
  最新: "Latest ",
  最新直播: "LIVE Training",
  直播中: "Live now",
  预告: "Preview",
  回放: "Replay",
  先人一步: "Stay ahead",
  现在就开始了解出海学堂: "by exploring TikTok for Business Academy now",
  请先登录: "Log in first",
  去登录: "Log in",
  登录方式: "Login method",
  感谢您的反馈: "Thanks for your feedback",
  N秒后自动关闭: "Closes in {text} seconds",
  选择登录账户继续操作: "Select a login account to continue",
  "此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。":
    "This course is tailored for agency partners and is only available for agencies. If you have any questions, please contact customer service for further assistance.",
  "此课程为代理合作伙伴定制,非代理商身份无使用权限。":
    "This course is tailored for agency partners and is only available for agencies. ",
  "如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。":
    "If you have any questions, please contact customer service for further assistance.",
  代理商: "Agency",
  品牌方: "CNOB Client",
  代理商简称: "Agency Name",
  "请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项":
    "Please search by keyword, if no results are found, choose another option.",
  其他: "Other",
  请输入代理商简称: "Please enter the agency name",
  "请输入姓名（请填写你在公司的真实姓名）":
    "Please enter your name (use your real name at the company)",
  岗位: "Position",
  请选择岗位信息: "Please select your position",
  请输入具体岗位信息: "Please enter your position",
  公司邮箱: "Company Email",
  请输入公司邮箱: "Please enter your Company Email",
  "提示: 提交成功后,请耐心等待管理员审核.":
    "Note: Admin approval may take some time. Please be patient.",
  "剩余审核次数:N次": "Remaining review attempts: {text}",
  主体名称: "Entity Name",
  请输入主体名称: "Please enter the entity name",
  "请准确填写您的开户主体信息。若信息偏差较大，我们将再次向您进行确认。":
    "Please provide the correct account entity information. If there are significant discrepancies, we will contact you for confirmation.",
  待审核: "Pending review",
  请填写岗位信息: "Please enter your position",
  请填写代理商简称: "Please enter the agency name",
  请输入正确的公司邮箱: "Please enter the correct Company Email",
  请选择学员类型: "Please select a learner type",
  学员类型: "Learner Type",
  请输入岗位信息: "Please enter your position",
  请输入姓名: "Please enter your name",
  "确认关闭？信息正确完善前，您的部分功能可能受限":
    "Are you sure you want to close it? Some features may be limited until your information is complete and accurate.",
  确定关闭: "Close",
  "您有新的消息！": "You have new messages!",
  信息: "Details",
  确定: "Confirm",
  暂无课程: "No courses available",
  认证科目简介: "Certification subject overview",
  认证课程学习: "Certification course study",
  预约考试: "Schedule exam",
  "认证/模拟考试": "Certification/Practice exams",
  修改考试场次: "Reschedule exam",
  "成绩待确认,请耐心等待!":
    "It may take some time for your score to be approved. Please be patient.",
  查看证书: "View certificate",
  获取考试信息: "Obtain exam info",
  课程反馈: "Course feedback",
  未开始: "Not started",
  以上内容对您是否有帮助: "Was the content above helpful to you?",
  点击评分: "Click to rate",
  试听: "Trial",
  添加飞书群组: "Add Lark group",
  请先在电脑端完成相关认证考试操作:
    "Please complete the relevant certification exam operations on PC first",
  好的: "OK",
  请先观看完所有章节: "Please watch all chapters first",
  "内容下架了！": "Content is no longer available",
  "此页面课程仅为代理商定制，非代理商身份不可用":
    "The courses on this page are tailored for agency partners and are only available for agencies.",
  信息完善: "Information Completion",
  完善: "Full",
  选择: "Select",
  预约成功: "Scheduled successfully",
  "考试已结束！": "Exam ended!",
  请先答完所有问题: "Please answer all questions first",
  不要重复提交试卷: "Exam paper already submitted",
  能力自测: "Self-assessment",
  暂无推荐课: "No recommended courses available",
  正在拼命加载中: "Loading…",
  "该场直播暂未开放，敬请期待":
    "This livestream has not started yet. Please stay tuned.",
  请用TTAM账号登录: "Please log in using your TikTok Ads Manager account",
  更多问题: "More questions",
  "以下是关于TikTok for Business 出海学堂 账户最常见的问题。":
    "Here are the most common questions about TikTok for Business Academy accounts and their answers.",
  "如有其他问题，请随时与我们联系":
    "For additional questions, feel free to contact us.",
  怎么称呼您: "How should we address you?",
  请输入您的全名: "Please enter your full name",
  您的公司名称: "Your company name",
  请输入公司名称: "Please enter your company name",
  销售姓名: "Sales representative name",
  请输入销售的姓名: "Please enter the name of your sales representative",
  请输入您的邮箱: "Please enter your email",
  "手机（选填）": "Mobile (optional)",
  请输入您的手机号码: "Please enter your mobile number",
  行业: "Industry",
  请选择所属行业: "Please select your industry",
  您的问题: "Your question",
  请简述一下您的问题: "Please briefly describe your question",
  请输入正确格式: "Please enter using the correct formatting",
  请输入销售名称: "Please enter the name of your sales representative",
  请描述一下您的问题: "Please describe your question",
  清除未读: "Mark as read",
  雷达图: "Radar chart",
  个人雷达图: "Personal radar chart",
  代理商雷达图: "Agency radar chart",
  昵称: "Nickname",
  能力专项: "Specialized skills",
  学习课程: "Take course",
  推荐学习计划: "Recommended learning plans",
  得分: "Score",
  观看: "View",
  正在加载: "Loading...",
  暂无内容: "No content available",
  选择筛选日历课程: "Select to filter calendar courses",
  暂无相关课程: "No relevant courses found",
  前往观看: "Go",
  前往预约: "Go",
  直播详情: "Livestream details",
  收到您的提交: "Your submission received",
  "我们会在 48 小时内跟您联系！": "We will contact you within 48 hours.",
  完成: "Completed",
  退出: "Exit",
  能力雷达: "Ability radar",
  营销认证: "Marketing certifications",
  讲师招募: "Instructor recruitment",
  学霸实时排行榜: "Real-time academic leaderboard",
  人才认证超能排行榜: "Talent certification super leaderboard",
  最新动态: "Latest news",
  查看详情: "View details",
  代理商学习计划: "Learning Plan",
  好课推荐: "Recommended courses",
  "平台鉴权中，成功后将自动跳转，请耐心等待":
    "Authentication is in progress, you will be redirected automatically upon success. Please be patient.",
  选择支付方式: "Select a payment method",
  个人支付: "Personal payment",
  邀请码核销: "Invite code redemption",
  请输入邀请码: "Please enter your invite code.",
  "若无法正常显示金额，刷新页面即可":
    "Refresh the page if the amount isn't displayed correctly.",
  本轮支付优惠截止时间: "This round of payment discount ends at",
  我已悉知并同意以上认证报考须知:
    "I have read and agreed to the above certification exam guidelines.",
  当前不在报名考试时间内: "Exam registration is currently closed",
  在您验证邀请码前: "Before verifying your invite code",
  营销认证考试协议: "Marketing Certification Exam Agreement",
  勾选同意后进行下一步骤: `Please check the box next to "Agree" to proceed to the next step`,
  请点击链接详细阅读: "Please click the link to read more details",
  证书详情: "Certificate details",
  请先阅读并同意考试条款: "Please read and agree to the exam terms first",
  请填写邀请码: "Please enter your invite code",
  邀请码错误: "Wrong invite code",
  支付校验错误: "Payment validation error",
  章节名称: "Chapter name",
  时间: "Time",
  暂无证书: "No certificates available",
  登录成功: "Login successful",
  登录失败: "Login failed",
  授权验证中: "Verifying permissions",
  课程资源: "Course resources",
  点击进入代理商专属课程资源:
    "Click to access exclusive course resources for agencies",
  点击能力雷达图查看个人能力分析:
    "Click the skill radar chart to view an analysis of your personal skills",
  学霸学时排行榜: "Learning Time Ranking",
  认证数量排行榜: "Certification quantity leaderboard",
  月度新增数量排行榜: "Monthly new certifications leaderboard",
  个人学习时长: "Individual Learning Record",
  查看: "View",
  本月: "Recommendation",
  必学: "",
  "完成此板块课程学习和考试，可在当月个人雷达图的计算中，获得对应能力项的学习积分":
    "After completing the courses and exams in this section, you will earn learning points for the respective skills, contributing to your personal radar chart for the current month.",
  能力分析雷达图: "Skill analysis radar chart",
  "雷达图生成依据为学员在营销认证中的答题表现及日常学习表现，计算维度包含（认证成绩+日常学习得分）":
    "The radar chart is generated based on a learner's performance in both marketing certifications and daily learning, calculated using certification and daily learning scores.",
  个人通用能力雷达图: "Overall personal skill radar chart",
  请选择证书行业: "Please select the certificate industry",
  个人: "Individual",
  行业能力雷达图: "Industry skill radar chart",
  所属公司能力雷达图: "Company skill radar chart",
  "推荐课程由个人能力雷达图表现为依据，依据用户需要提升的能力项，智能推荐课程。助力你成为多边形战士！":
    "Recommended courses are intelligently tailored to enhance your skills based on your personal skill radar chart. They are intended to help you become an all-around advertiser!",
  学习计划: " Learning plans",
  动态: "updates",
  获得认证证书数: "Certificates obtained",
  在线时长: "Online duration",
  能力分析: "Skill analysis",

  权限提示: "Permission prompt",
  "学习时长：30天内累积学习时长":
    "Learning duration: Accumulated learning time within 30 days",
  "排名箭头：体现用户30天内排名变化趋势":
    "Ranking Arrow: Reflects the trend of user ranking changes within 30 days",
  "认证证书排行：在官方代理营销认证考试中，累积通过人数在所有官方代理中的排名":
    "Certification ranking: The cumulative number of successful candidates in the official agency marketing certification exam, ranked among all official agencies",
  百分比: "percentage",
  精品: "Featured",
  暂无试卷: "No exam",
  关闭: "Close",
  "若您有该课程学习码，请您准确填写！":
    "If you have the learning code for this course, please fill it in accurately!",
  "若您没有，请您点击关闭按钮进入课程学习。":
    "If you don't have it, please click the close button to enter the course learning.",
  请输入您的学习码: "Please enter your learning code",
  学习码: "Learning code",
  "开始学习前，请您先完成认证能力测评":
    "Before starting your studies, please complete the certification ability assessment",
  去认证考试: "Go to the certification exam",
  信息完善SEA: "Information Completion",
  "此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。SEA":
    "This course is tailored for agency partners and is only available for agencies. If you have any questions, please contact customer service for further assistance.",
  学员类型SEA: "Learner Type",
  代理商SEA: "CNOB Agency",
  品牌方SEA: "CNOB Client",
  代理商简称SEA: "Agency Name",
  "请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项SEA":
    "Please search by keyword, if no results are found, choose another option.",
  其他SEA: "Other",
  请输入代理商简称SEA: "Please enter the agency name",
  "请输入姓名（请填写你在公司的真实姓名）SEA":
    "Please enter your name (use your real name at the company)",
  岗位SEA: "Position",
  请选择岗位信息SEA: "Please select your position",
  请输入具体岗位信息SEA: "Please enter your position",
  公司邮箱SEA: "Company Email",
  请输入公司邮箱SEA: "Please enter your Company Email",
  "提示: 提交成功后,请耐心等待管理员审核.SEA":
    "Note: Admin approval may take some time. Please be patient.",
  "剩余审核次数:N次SEA": "Remaining review attempts: {text}",
  姓名SEA: "Learner Name",
  学员名称SEA:"Learner Name",
  提交SEA: "Submit",
  待审核SEA: "Pending review",
  请输入正确的公司邮箱SEA: "Please enter the correct Company Email",
  请输入岗位信息SEA: "Please enter your position",
  请输入姓名SEA: "Please enter your name",
  完课考试排行榜: "Quiz Score Ranking",

  素材服务商身份报名: "Registration as a Material Service Provider",
  素材服务商名称: "Name of Material Service Provider",
  请选择素材服务商名称:
    "Please select the name of the material service provider",

  中国跨境代理商: "China Outbound Agency",
  中国跨境商家: "China Outbound Client",
  中国跨境代理商SEA: "China Outbound Agency",
  中国跨境商家SEA: "China Outbound Client",
  链接: "Link",
  学员答题详情: "Learner answer details",
  问题答案: "Answer",
  "考试时长（分钟）": "mins",
  试卷标题: "Exam paper title",
  试卷时间: "Exam duration",
  学员UID: "Learner UID",
  考试时间: "Exam time",
  答题时长: "Answer duration",
  返回认证: "Return authentication",
  认证能力测评: "Certification Capability Assessment",
  模拟练习题库: "Simulated practice question bank",
  总表: "Summary Table",
  线下培训: "Offline training",
  系统提示: "system prompt",
  "当前检测到您的账号尚未绑定邮箱，这将导致无法完成考试认证。为确保您能顺利参加考试，请尽快点击下方链接完成邮箱绑定及信息完善：":
    "We have detected that your account has not been linked to an email, which will result in the inability to complete the exam authentication. To ensure that you can participate in the exam smoothly, please click on the link below as soon as possible to complete email binding and information completion:",
  点击完善: "Click to complete",
  已完成绑定: "Binding completed",
  新客户成长计划: "New Customer Growth Plan",
  "精心打造客户成长计划，整合优质资源，提供定制策略与专业指导，助力客户实现业绩持续跃升。":
    "Elaborately craft customer growth plans, integrate premium resources, offer tailored strategies and professional guidance, and assist customers in achieving continuous performance enhancement.",

  //----志成添加-------
  电商出海新星成长计划:
    "E-commerce Overseas Rising Star <span>Growth Plan</span>",
  还需学习: "Continue learning",
  您现在是否已掌握该门课程知识:
    "Have you now mastered the knowledge of this course",
  签到成功: "Sign in successful",
  直播签到: "Live check-in",
  初级课程: "Elementary courses",
  中级课程: "Intermediate course",
  高级课程: "Advanced courses",
  操作成功: "Operation successful",
  //----end----------
  "如您的PDF课程无法达成100%完成，请调整您的浏览器和文件框的缩放比例至100%。":
    "Hi All, if your PDF course fails to reach 100% completion, please adjust the zoom level of your browser and file frame to 100%.",
  "成为排名靠前的学习者！": "Be top-ranked learners!",
  "立即开始学习！": "Start learning now!",
  学习问题收集箱: "Q&A Collection Box",
  热门文章: "Trending Articles",
  问题收集: "Q&A Collection",
  查看时长: "View Learning Duration",
  复制成功: "copied",
  "如您在登陆过程中遇到问题请点击解决方案文档并按步骤操作，如仍无法登陆，请联系人工客服解决":
    "If you encounter any issues during the login process, please click on the solution document and follow the steps. If you still cannot log in, please contact the online customer service for assistance.",
  解决方案: "Solution Document",
  直播培训: "LIVE Training",
  直播培训主题收集箱: "Collection Pool of LIVE Training Topics",
  前往: "Access",
  福利课程获取请点击: "Click here to access the free courses",
  福利课程: "Free Courses",

  //2026-01-14添加
  必修: "Compulsory",

  评分: "Score",
  浏览量: "Views",
  次观看: "Views",
  广告主: "Advertiser",
  学习中心: "Learning Center",
  为出海品牌打造的官方培训基地:
    "An official training base tailored for brands expanding overseas",
  初级: "Basic",
  进阶: "Advanced",
  跨境认证介绍: "Introduction",
  考试报名须知: "Notice",
  官方认证查询: "Query",
  "TikTok for Business 认证体系": "TikTok for Business Certification System",
  认证上新: "Certification Update",
  "TikTok for Business 认证权益": "TikTok for Business certified benefits",
  跨境营销认证权益: "Cross-border marketing certification benefits",
  理解: "Understanding",
  入局: "Enter the game",
  跨境营销: "Cross-border marketing",
  知识体系: "Knowledge system",
  出海市场: "Overseas market",
  "跨境营销信息流、创意素材、闭环投流等全面认知":
    "Comprehensive understanding of cross-border marketing information flow, creative materials, closed-loop traffic acquisition, etc",
  "从营销趋势到实操技巧，全流程学习":
    "From marketing trends to practical skills, learn the entire process",
  "获得官方人才标准认证，提升出海方向就业竞争力":
    "Obtain official talent standard certification to enhance employment competitiveness in the overseas market",
  高级: "Advanced",
  专业化学习: "Specialized learning",
  专业化课程: "Specialized courses",
  最热门证书: "Popular certificate",
  "通过出海学堂学习，您可以培养宝贵的技能，获得职业证书。":
    "By studying at the Global Business School, you can develop valuable skills and obtain professional certificates.",
  "出海学堂专业化课程，包含值得信赖，符合标准的课程。覆盖电商，应用，美妆，通用，3C等。":
    "The specialized courses offered by Haishang Academy are trustworthy and up to standard, covering various fields such as e-commerce, applications, beauty and makeup, general knowledge, and 3C products.",
  "出海学堂为您提供，最受欢迎的课程，为热门职业做好就业准备。":
    "Go Global Academy offers you the most popular courses to prepare you for employment in hot careers.",
  考试场次: "Exam session",
  了解更多认证: "Learn more about certifications",
  课程直达: "Direct Course Link",
  "此内容为CNOB/SEA代理合作伙伴定制,非代理商身份无使用权限。":
    "This page is customized for CNOB/SEA agency partners, and non-agency users do not have permission to use it.",
   "我还未成为 TikTok 广告主":"I don't have TikTok for Business account",
   "我是TikTok广告主/代理商":"I have TikTok for Business account",
   "我是内部员工":"I'm a TikTok employee",

   "请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！":"Please complete and accurately fill in all information to ensure its authenticity and validity.Only after the information is filled in correctly can you normally enter the platform to study and receive incentives for subsequent platform activities.All your information will be strictly confidential and will not be disclosed externally. Thank you for your cooperation!",
  "请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！SEA":"Please complete and accurately fill in all information to ensure its authenticity and validity.Only after the information is filled in correctly can you normally enter the platform to study and receive incentives for subsequent platform activities.All your information will be strictly confidential and will not be disclosed externally. Thank you for your cooperation!",
  "请准确填写信息并选择正确主体，否则将无法正常进入学习": "Please fill in the information accurately and select the correct entity; otherwise, you will not be able to enter the learning process normally", 
  "请准确填写信息并选择正确主体，否则将无法正常进入学习SEA": "Please fill in the information accurately and select the correct entity; otherwise, you will not be able to enter the learning process normally",
  "填写方式":"Information Type",
  "主体名称填写":"Account Name",
  "请选择主体名称":"Please select the Account Name",
  "请输入":"Please enter",
  "如您在填写过程中遇到问题,请扫码入群反馈":"If you encounter any issues,please scan the QR code to join the group and ask for help",
  "如您在填写过程中遇到问题,请扫码入群反馈SEA":"If you encounter any issues,please scan the QR code to join the group and ask for help",
  "请选择任一填写":"Please select any one of the following options",
  "查找方式":"Search Method",
  "请使用您的TTAM/BC账号及密码登录":"Please log in with your TTAM/BC account and password",
  "如您还未成为TikTok for Business的广告主/代理商，请先完成":"If you have not yet become an advertiser/agency on TikTok for Business, please first complete",
  "注册":"registration",
  "忘记密码请返回":"If you forget your password, please return to",
  "平台进行找回":"to retrieve it",
  "您的TikTok for Business账号":" Your TikTok for Business account",
  "加入":"Join ",
  "TikTok for Business打造的培训基地，在这里品牌和代理可以获取丰富的全行业课程和营销知识":"TikTok for Business is a training base where brands and agents can access a wealth of industry wide courses and marketing knowledge",
  "忘记密码":"Forgot password",
  "手机号":"Phone number",
  "请输入手机号":"Please enter your phone number",
  "请输入邮箱":"Please enter your email",
  "请输入密码":"Please enter the password",
  "请输入验证码":"Enter the verification code",
  "发送验证码":"Send code",
  "使用短信验证码登录":"Log in with SMS Code",
  "使用密码登录":"Log in with Password",
  "账号或密码错误，请重试":"Account or password error, please try again",
  "确认手机号":"Confirm phone number",
  "请注意：为了您的账号安全，验证码已发送至":"Please note: The verification code has been sent to",
  "没有收到验证码？":"Did you receive the verification code?",
  "再次发送":"Resend",
  "验证码验证失败":"Verification code verification failed",
  "确认电子邮箱":"Confirm email",
  "验证码发送失败":"Verification code send failed",
  "密码验证":"Password verification",
  "请注意：为了您的账号安全，请输入您的登录密码":"Please note: For the security of your account, please enter your login password",
  "密码长度必须在6-20位之间":"The password length must be between 6 and 20 characters",
  "直播简介":"Live Introduction",
  "直播介绍": "Live Content",
  "进入直播":"Enter Live",
  "本直播链接仅支持当前设备访问转发他人将无法正常观看":"This live link only supports access from the current device. Forwarding to others will not allow them to watch properly",
  "如无法访问可联系管理员或扫码入群反馈":"If you cannot access, please contact the administrator or scan the QR code to enter the group and provide feedback",
  "集团名称":"Group Name",
};
